function WiritizeText(val) {
  // eslint-disable-next-line no-undef
  var wirisImage = WirisPlugin.Parser.initParse(val)
  return wirisImage
}

export { WiritizeText }
